
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { translate } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'
import amber from '@material-ui/core/colors/amber'
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import { Warning } from "@material-ui/icons"
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import isFunction from 'lodash/isFunction'
import {ADMIN_EMAIL} from '../../constants'


const styles = theme => ({
  buttonProgress: {...theme.button.progress},
  hidden: {visibility: 'hidden'},
  link: {color: theme.links.error.color},
  linkWrapper: {
    margin: '20px auto 0 auto',
    textAlign: 'center'
  },
  root: {
    flexGrow: 1,
    marginTop: 25
  },
  fullWidth: {width: '100%'},
  warning: {
    color: amber[700],
  }
})

// exported for unit testing purposes ( see https://react.i18next.com/misc/testing )
export class Login extends Component {

  static HELPER_TEXT = 'Incorrect Username or Password'

  constructor(props) {
    super(props)
    this.state = {
      username: '',
      password: '',
      isCapsLockOn: false
    }

  }

  handleChange(event) {
    this.setState({[event.target.name]: event.target.value})
    if(isFunction(this.props.onChange)) {
      this.props.onChange()
    }
  }

  handleOnKeyUp(event) {
    // enter key for submit
    if(event.key === 'Enter' && !this.isLoginDisabled()) {
      this.props.onSubmit(this.state.username, this.state.password)
    }
  }

  isLoginDisabled = () => !this.state.username.length || !this.state.password.length

  checkCapsLock = event => (
    this.setState({ 
      isCapsLockOn: event.getModifierState("CapsLock")
    })
  )

  renderInvalidCredentials = () => (
    this.props.errors.invalidCredentials && (
      <FormHelperText 
        id="password-helper-text-error"
        error={this.props.errors.invalidCredentials}
      >{this.props.t(Login.HELPER_TEXT)}</FormHelperText>
    )
  )

  renderCapsLockIsOn = () => (
    (this.state.isCapsLockOn && !this.props.errors.invalidCredentials) && (
      <FormHelperText 
        id="password-helper-text-warning"
      >{this.props.t('Caps Lock Warning')}</FormHelperText>            
    )
  )

  render() {
    const {classes, errors, isRequestingAccess, t } = this.props
    const { password, username, isCapsLockOn } = this.state
    const isLoginDisabled = this.isLoginDisabled()

    return (
      <div
        className={classes.root}
        onKeyUp={this.handleOnKeyUp.bind(this)}
      >
        <Grid
          container
          justify="center"
          alignContent="space-around"
          spacing={24}
        >
          <Grid item xs={10}>
            <TextField
              autoFocus={true}
              fullWidth
              error={errors.invalidCredentials}
              label={t('Username')}
              name="username"
              onChange={this.handleChange.bind(this)}
              value={username}
            />
          </Grid>
          <Grid item xs={10}>
          <FormControl fullWidth>
            <InputLabel htmlFor="password">{t('Password')}</InputLabel>
            <Input
              id="password"
              name="password"
              type="password"
              value={password}
              fullWidth
              error={errors.invalidCredentials}
              onChange={this.handleChange.bind(this)}
              onKeyDown={this.checkCapsLock}
              onKeyUp={this.checkCapsLock}
              onMouseDown={this.checkCapsLock}          
              endAdornment={isCapsLockOn && (
                <InputAdornment position="end" className={classes.warning}>
                  <Warning />
                </InputAdornment>
              )}
            />
            {this.renderInvalidCredentials()}
            {this.renderCapsLockIsOn()}
            {(!errors.invalidCredentials && !isCapsLockOn) && <FormHelperText />}
          </FormControl>
          </Grid>
          <Grid item xs={10} style={{marginTop: 20}}>
            {this.props.penultSlot}
          </Grid>
          <Grid item xs={10} style={{position: "relative"}}>
            <Button
              className={classes.fullWidth}
              color="secondary"
              disabled={isLoginDisabled}
              onClick={() => this.props.onSubmit(username, password)}
              variant="contained"
            >
              {t('Log In')}
            </Button>
            {isRequestingAccess && (
              <CircularProgress
                className={classes.buttonProgress}
                size={24}
              />
            )}
          </Grid>
          <Grid className={classes.linkWrapper} item xs="auto"
            dangerouslySetInnerHTML={{__html: t('For More Information', {EMAILLINK: ADMIN_EMAIL})}}
          >
          </Grid>
        </Grid>
      </div>
    )
  }
}

Login.propTypes = {
  errors: PropTypes.shape({
    invalidCredentials: PropTypes.bool
  }),
  onChange: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  penultSlot: PropTypes.element
}

export default compose(
  withStyles(styles),
  translate(),
)(Login)


// WEBPACK FOOTER //
// ./src/components/login/Login.js